import { format, parse } from 'date-fns'

const formatDate = (date) => format(parse(date, 'yyyyMMdd', new Date()), 'EEE, MMM d')

const getFormattedDate = (tripSlices, tripType) => {
  const origin = tripSlices?.[0]?.date ? formatDate(tripSlices[0].date) : null

  if (!origin) {
    return ''
  }

  if (tripType === 'RT') {
    return `${origin} - ${formatDate(tripSlices[0].returnDate)}`
  } else if (tripType === 'MD') {
    return `${origin} - ${formatDate(tripSlices[tripSlices.length - 1].date)}`
  }
}

export { getFormattedDate }
